<!-- Linguetta fissa al bordo destro: visibile solo a pannello chiuso -->
<button
  type="button"
  class="attachments-handle"
  *ngIf="!visible"
  (click)="toggle()"
  aria-label="Apri l'elenco degli allegati"
  pTooltip="Allegati"
  tooltipPosition="left">
  <i class="pi pi-paperclip"></i>
  <span class="handle-label">Allegati</span>
  <span
    class="handle-count"
    *ngIf="attachments.length">
    {{ attachments.length }}
  </span>
</button>

<!-- Pannello a scomparsa: scorre da destra verso sinistra. Non usa p-sidebar perché gli stili
     globali dell'app lo nascondono sopra i 768px (servono al menu laterale mobile). -->
<aside
  class="attachments-drawer"
  [class.open]="visible"
  role="complementary"
  aria-label="Allegati"
  [attr.aria-hidden]="!visible">
  <header class="drawer-header">
    <h3 class="my-0">
      <i class="pi pi-paperclip mr-2"></i>Allegati
      <span
        class="grey-text text-base"
        *ngIf="attachments.length"
        >({{ attachments.length }})</span
      >
    </h3>
    <button
      type="button"
      class="drawer-close"
      (click)="close()"
      aria-label="Chiudi l'elenco degli allegati">
      <i class="pi pi-times"></i>
    </button>
  </header>

  <div class="drawer-body">
    <div
      class="flex justify-content-end mb-3"
      *ngIf="canManage">
      <p-button
        type="button"
        icon="pi pi-upload"
        label="Aggiungi o elimina allegati"
        styleClass="butt"
        [rounded]="true"
        (click)="manage.emit()"></p-button>
    </div>

    <div
      class="text-center py-4"
      *ngIf="loading && !attachments.length">
      <i class="pi pi-spin pi-spinner"></i>
    </div>

    <p
      class="grey-text text-center py-4"
      *ngIf="loadFailed">
      Impossibile caricare gli allegati.
      <a
        class="cursor-pointer"
        (click)="load()"
        >Riprova</a
      >
    </p>

    <p
      class="grey-text text-center py-4"
      *ngIf="!loading && !loadFailed && !attachments.length">
      Nessun allegato.
    </p>

    <ul class="attachments-list">
      <li
        *ngFor="let item of attachments; trackBy: trackById"
        class="attachment">
        <i [class]="iconFor(item)"></i>
        <div class="attachment-info">
          <span
            class="attachment-name"
            [title]="item.media.original_name"
            >{{ item.media.original_name }}</span
          >
          <small class="grey-text">
            {{ item.attachment_type.type_description }} ·
            {{ item.media.created_on | date: 'dd/MM/yyyy HH:mm' }} ·
            {{ +item.media.size | filesize }}
          </small>
        </div>
        <p-button
          type="button"
          icon="pi pi-download"
          styleClass="butt"
          [rounded]="true"
          [loading]="downloadingId === item.media.id"
          pTooltip="Scarica"
          tooltipPosition="left"
          (click)="download(item)"></p-button>
      </li>
    </ul>
  </div>
</aside>
